import privateImage from "../assets/png/about_professional.jpg";

export const aboutPrivateData = {
  title: "O mnie prywatnie",
  description1:
    "Wszystko zaczęło się od miłości do piłki ręcznej w młodości, a później odkryłam pasję do ludzkiego ciała i ruchu. Od 2014 roku trenuję CrossFit, i ta pasja trwa do dziś. Treningi zawodnicze pozwoliły mi zgłębić granice ludzkiego ciała i umysłu, co ułatwia mi współpracę z sportowcami, amatorami i z Tobą.",
  description2:
    "Jestem pasjonatem odkrywania zdrowia i świata. Fascynuje mnie ludzkie ciało, biomechanika, różne metodyki i neurobiologia. Uwielbiam poznawać nowe sporty, być w ruchu i śledzić nowinki z medycyny i sportu. Mimo swojego introwertyzmu ;) utrzymuję kontakty z osteopatami, lekarzami, trenerami i naturopatami, obserwując współpracę tych dziedzin, by lepiej pomóc Tobie.",
  image: privateImage,
};
